import type { ComponentType } from 'react';

import { ROUTE_PATTERNS } from '@/shared/config/routes';

import {
  AudienceProfiles,
  BrandXray,
  BusinessChallenge,
  BusinessOpportunities,
  CategoryCompetition,
  CultureContext,
  ExecutiveSnapshot,
  MarketingPerformance,
  CreativeLandscape,
  MediaLandscape,
} from './sections';
import type { AnalysisSectionProps } from './utils/useAnalysisFromContext';

/**
 * The report's sections in reading order — the order the sidebar navigates and
 * the order a whole-report render stacks them in. Single source for both the
 * slug lookup the print page needs and the sequence the Library preview walks,
 * so the two can't drift.
 */
export const ANALYSIS_REPORT_SECTIONS: ReadonlyArray<{
  slug: string;
  Component: ComponentType<AnalysisSectionProps>;
}> = [
  { slug: ROUTE_PATTERNS.IQ_SECTION_EXECUTIVE_SNAPSHOT, Component: ExecutiveSnapshot },
  { slug: ROUTE_PATTERNS.IQ_SECTION_BUSINESS_CHALLENGE, Component: BusinessChallenge },
  { slug: ROUTE_PATTERNS.IQ_SECTION_CULTURE_CONTEXT, Component: CultureContext },
  { slug: ROUTE_PATTERNS.IQ_SECTION_BRAND_XRAY, Component: BrandXray },
  { slug: ROUTE_PATTERNS.IQ_SECTION_CATEGORY_COMPETITION, Component: CategoryCompetition },
  { slug: ROUTE_PATTERNS.IQ_SECTION_BUSINESS_OPPORTUNITIES, Component: BusinessOpportunities },
  { slug: ROUTE_PATTERNS.IQ_SECTION_AUDIENCE_PROFILES, Component: AudienceProfiles },
  { slug: ROUTE_PATTERNS.IQ_SECTION_MARKETING_PERFORMANCE, Component: MarketingPerformance },
  { slug: ROUTE_PATTERNS.IQ_SECTION_MEDIA_LANDSCAPE, Component: MediaLandscape },
  { slug: ROUTE_PATTERNS.IQ_SECTION_CREATIVE_LANDSCAPE, Component: CreativeLandscape },
];

export const SECTION_BY_SLUG: Record<
  string,
  ComponentType<AnalysisSectionProps>
> = Object.fromEntries(ANALYSIS_REPORT_SECTIONS.map(({ slug, Component }) => [slug, Component]));
